import React, { useState } from 'react';
import axios from 'axios'
import { Dropdown, Button, Modal, Form } from 'react-bootstrap';
import { AiOutlineUpload } from 'react-icons/ai';
import Spinner from 'react-bootstrap/Spinner';

// pagina fondamentale per il check dei documenti         {/* idroslab  */}

async function post_pdf({ file_blobbato} , descrizione, tipologia_documento) {
    console.log(descrizione)
    console.log(tipologia_documento)

    const formData = new FormData();
    formData.append("file_blobbato", file_blobbato)
//    formData.append("descrizione", descrizione)
    const result = await axios.post('/transfer_s3/file_pdf/' + descrizione + '/' + tipologia_documento, formData, { headers: { 'Content-Type': 'multipart/form-data' } })

    console.log('CCCCCCCCCCCCCCCCCCCCCCCCCCCCC  tornato nel front end')

    console.log(result)
    return result.data
}


const Aggiungi_documentazione_attore = (props) => {
    const [file, setFile] = useState()
    const [description, setDescription] = useState("")
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const [show_spinner, SET_show_spinner] = useState(false);
    
    
    const submit = async event => {
        event.preventDefault()
        let result = null
        let stringa_per_chiamata_server = ''
        SET_show_spinner (true)     
        if (props.attore_tipo === 'ditta') {
            result = await post_pdf({ file_blobbato: file }, props.attore.ragione_sociale, props.tipologia_documento)
            stringa_per_chiamata_server = '/ditte/aggiungi_documenti_pdf/'
        } 
        if (props.attore_tipo === 'alunno') {
            result = await post_pdf({ file_blobbato: file }, props.attore.cognome + '_' + props.attore.nome, props.tipologia_documento)
            stringa_per_chiamata_server = '/alunni/aggiungi_documenti_pdf/'
        }
        if (props.attore_tipo === 'progetto') {
            result = await post_pdf({ file_blobbato: file }, props.attore.id_alunno.cognome + '_' + props.attore.id_alunno.nome + '_vs_' + props.attore.id_ditta.ragione_sociale , props.tipologia_documento)
            stringa_per_chiamata_server = '/progetti/aggiungi_documenti_pdf/'
        }
        if (props.attore_tipo === 'classi') {
            result = await post_pdf({ file_blobbato: file },  'Template_word_docx_', props.tipologia_documento)
            stringa_per_chiamata_server = '/classi/aggiungi_documenti_pdf/'
        }

        SET_show_spinner (false)     
        console.log(result)
        console.log(result.Key)
        console.log(stringa_per_chiamata_server)
        console.log(props.attore._id)
        console.log(props.tutor._id)

        axios.put(stringa_per_chiamata_server + props.attore._id + '/' + result.Key 
                                                   + '/' + props.tipologia_documento + '/' + props.tutor._id)
            .then((res) => {
                console.log('Aggiunto un documento')
                props.SET_variab_aggiorna(current => !current)

            }).catch((error) => {
                console.log(error)
            });
        setShow(false)
 
    }


    const fileSelected = event => {
        const file = event.target.files[0]
        setFile(file)
    }

    const handleSubmit1 = (e) => {
        alert('scrivi qualcosa')
    }


    return (<div>
        <i class="bi bi-envelope"></i>
        <Dropdown.Item onClick={() => { setShow(true) }} > <div class="d-flex justify-content-between"> {props.tipologia_documento.includes('File_word_rischio') ? "File Word" : "File PDF"} -  
      
        {!props.tipologia_documento.includes('formazione') && ' ' + props.tipologia_documento + ' '} 
        {props.tipologia_documento === 'formazione_A' && ' Formazione Rischio Basso ' }
        {props.tipologia_documento === 'formazione_B' && ' Formazione Rischio Medio ' }
        {props.tipologia_documento === 'formazione_C' && ' Formazione Rischio Alto ' } 

        
        <AiOutlineUpload /> </div>
            
            </Dropdown.Item>

        <Modal
            show={show}
            size="lg"
            onHide={handleClose}
            backdrop="static"
            keyboard={false}
        >
        <Modal.Header closeButton>
            <Modal.Title>Caricamento</Modal.Title>
        </Modal.Header>
            <Modal.Dialog>
                <p>
                    
                </p>
               
                <Form onSubmit={submit}>
                <Form.Group controlId="formFile" className="mb-3">
                    <Form.Label>Seleziona un file pdf da caricare</Form.Label>
                    <Form.Control type="file" onChange={fileSelected} accept={props.tipologia_documento.includes('File_word_rischio') ? "application/msword" : "application/pdf"} />
                </Form.Group>
                {show_spinner && <Spinner animation="border" role="status">
                       <span className="visually-hidden">Loading...</span>
                </Spinner>}
                
                <div className="d-flex flex-row-reverse bd-highlight">

                <Button variant="primary" type="submit"  >
                    Carica
                </Button>
                </div>
               
                </Form>
            </Modal.Dialog>
        </Modal>
    </div>

    )
}
export default Aggiungi_documentazione_attore;
